import { apiClient } from '@/core/api';

/** P&L payload returned by `/command-center/reports/pnl/`. */
export interface PnlReport {
  income_base_usd: number | string;
  expense_base_usd: number | string;
  net_base_usd: number | string;
  /** Trailing 3-month average income (proxy). */
  mrr_estimate_base_usd: number | string;
  monthly: {
    month: string;
    income: number | string;
    expense: number | string;
    net: number | string;
  }[];
}

/** Row returned by `/command-center/reports/revenue-by-client/`. */
export interface RevenueByClientRow {
  company: string;
  revenue_base_usd: number | string;
}

/** Both endpoints are finance-role gated; 403 for non-finance callers. */
export async function getPnl(): Promise<PnlReport> {
  const { data } = await apiClient.get<PnlReport>('/command-center/reports/pnl/');
  return data;
}

export async function getRevenueByClient(): Promise<RevenueByClientRow[]> {
  const { data } = await apiClient.get<RevenueByClientRow[]>(
    '/command-center/reports/revenue-by-client/',
  );
  return data;
}
